import { getResponseData } from "../../../../../reactQuery/response";

export function normalizeBoardHeaderData(boardName) {
  return getResponseData(
    boardName,
    boardName?.data?.responseData ?? boardName ?? null
  );
}
